import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add CSRF token to axios requests
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

// Update axios CSRF token when meta tag changes (after Inertia navigation)
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'content') {
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = mutation.target.getAttribute('content');
        }
    });
});

const metaTag = document.querySelector('meta[name="csrf-token"]');
if (metaTag) {
    observer.observe(metaTag, { attributes: true });
}
